/* src/app/user/user.component.scss */
.mat-cell {
  text-align: left;
}
.mat-row {
  border-color: #605959;
}
h2 {
  text-align: right;
  padding-right: 20px;
  margin-top: -20px;
}
button {
  border-radius: 10px;
}
.mat-column-hr {
  max-width: 50px;
}
.mat-column-super {
  max-width: 80px;
}
.userEmail:hover {
  cursor: pointer;
}
.client-name {
  font-size: 1.5rem;
}
.menu {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding-top: 20px;
}
.menu input {
  line-height: 2rem;
}
.menu div {
  margin-left: 20px;
}
/*# sourceMappingURL=user.component.css.map */
